import React from 'react';

interface Props {
  children: React.ReactNode;
  /** Label shown in the error fallback (e.g., section name). */
  label?: string;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[ErrorBoundary${this.props.label ? `: ${this.props.label}` : ''}]`, error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6 bg-red-50 border border-red-200 rounded-lg text-center">
          <div className="text-red-600 font-medium text-sm mb-1">
            {this.props.label ? `${this.props.label} encountered an error` : 'Something went wrong'}
          </div>
          <div className="text-red-500 text-xs font-mono mb-3">{this.state.error.message}</div>
          <button
            type="button"
            className="px-3 py-1.5 text-xs bg-red-600 text-white rounded hover:bg-red-700"
            onClick={() => this.setState({ error: null })}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
